import { render, staticRenderFns } from "./AuthorizationView.vue?vue&type=template&id=c49c231a&"
import script from "./AuthorizationView.vue?vue&type=script&lang=js&"
export * from "./AuthorizationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports